import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Session } from '../../types/api';

interface ActivityFeedItemProps {
  session: Session;
}

export function ActivityFeedItem({ session }: ActivityFeedItemProps) {
  const participantNames = session.participants.map(p => p.clientName).join(', ');

  return (
    <Card>
      <CardHeader>
        <div className="flex justify-between items-start">
          <div>
            <CardTitle className="text-lg">Session with {participantNames}</CardTitle>
            <CardDescription>{new Date(session.startTime).toLocaleString()}</CardDescription>
          </div>
          <span className="text-sm font-medium text-gray-500">Completed</span>
        </div>
      </CardHeader>
      <CardContent>
        <p className="text-sm text-gray-700">{session.notes || "No notes for this session."}</p>
      </CardContent>
      <CardFooter className="flex justify-between items-center">
        <div className="text-sm text-gray-500">
          <span>{session.exercises.length} Exercises</span>
        </div>
        <Link to={`/studio/sessions/${session.sessionGuid}`}>
          <Button variant="outline" size="sm">
            View Details
          </Button>
        </Link>
      </CardFooter>
    </Card>
  );
}